var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#272C65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8526 29.1041C53.3169 27.632 55.6948 27.632 57.1591 29.1041L75.9018 47.9475C77.3661 49.4197 77.3661 51.8104 75.9018 53.2826C74.4375 54.7547 72.0595 54.7547 70.5953 53.2826L58.2485 40.8577V76.9899C58.2485 79.0745 56.5734 80.7586 54.5 80.7586C52.4266 80.7586 50.7515 79.0745 50.7515 76.9899V40.8695L38.4047 53.2708C36.9405 54.7429 34.5625 54.7429 33.0982 53.2708C31.6339 51.7986 31.6339 49.4079 33.0982 47.9357L51.8409 29.0923L51.8526 29.1041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.42f085c01a73dc2563cbbdbca70419d8.svg";
export { ForwardRef as ReactComponent };